module.exports = __webpack_public_path__ + "static/media/home-slider-banner-6.1adab47d.png";